import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  claimId: string;
  lmnId: string;
  updateClaimStatus?: boolean;
}

const useLinkLmnToClaimQuery = () => {
  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) => api.put(API_URL.CLAIMS_LETTER_OF_MEDICAL_NECESSITY_BY_CLAIM_ID_LMN_ID(payload?.claimId, payload?.lmnId), null, {
      params: {
        updateClaimStatus: payload?.updateClaimStatus ? undefined : false,
      },
    })
  );

  return {
    linkLmnToClaim: mutateAsync,
    isLinkLmnToClaimLoading: isLoading,
  };
};

export default useLinkLmnToClaimQuery;
